import axios from 'axios';

export const api = axios.create({ baseURL: '/api/enrollment' });
export function invitationToken() { return sessionStorage.getItem('peacemakers-enrollment-invitation'); }
export function useInvitation() {
  const hash = new URLSearchParams(window.location.hash.substring(1));
  const token = hash.get('invite');
  if (token) {
    sessionStorage.setItem('peacemakers-enrollment-invitation', token);
    history.replaceState(null, '', window.location.pathname);
  }
  const saved = invitationToken();
  if (saved) api.defaults.headers.common.Authorization = `Bearer ${saved}`;
  return saved;
}
export async function csrf() {
  const { data } = await axios.post('/api/auth/session/token');
  api.defaults.headers.common['X-XSRF-TOKEN'] = data.token;
}
export function errorMessage(e) {
  if (e.response && e.response.status === 401) return 'Please sign in to your school account, then return to this page.';
  if (e.response && e.response.status === 403) return 'Your account does not have access to this action.';
  if (e.response && e.response.status === 429) return 'Too many requests. Please wait a minute and try again.';
  const data = e.response && e.response.data;
  return (data && (data.message || (data.errors && Object.values(data.errors).flat().join(' ')))) || 'We could not complete that request. Please try again.';
}
export function money(cents) { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((cents || 0) / 100); }
export function statusLabel(value) {
  return ({ Submitted: 'Awaiting review', NotStarted: 'Not started', Creating: 'Checkout started', Checkout: 'Awaiting payment', Pending: 'Bank payment processing', Paid: 'Paid', Failed: 'Payment failed', Returned: 'Payment returned', PartiallyRefunded: 'Partially refunded', Refunded: 'Refunded', Disputed: 'Payment disputed', Uncollectible: 'Needs review', Waived: 'Tuition waived', External: 'Arranged separately' })[value] || value;
}
export function statusClass(value) {
  if (['Approved', 'Paid', 'Waived'].includes(value)) return 'badge-success';
  if (['Declined', 'Failed', 'Returned', 'Disputed', 'Uncollectible'].includes(value)) return 'badge-danger';
  if (['Submitted', 'Creating', 'Checkout', 'Pending', 'PartiallyRefunded', 'Refunded'].includes(value)) return 'badge-warning';
  return '';
}
export function date(value) { return value ? new Date(value).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) : '—'; }
